export default "__VITE_ASSET__DJo6VkDT__"